import { removeLocalStorageItem } from "@/utils/common";

export const clearCurrentLeagueId = () => {
  removeLocalStorageItem("leagueId");
};
